import React, { useEffect, useRef, useState } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import "./textEditorStyles.css";

type RichTextEditorProps = {
  value?: string;
  onChange: (content: string) => void;
  setError?: (msg: string) => void;
};

const MAX_LENGTH = 5000;

const RichTextEditor: React.FC<RichTextEditorProps> = ({ value, onChange,setError }) => {
  const editorRef = useRef<HTMLDivElement | null>(null);
  const quillInstance = useRef<Quill | null>(null);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    const toolbarOptions = [
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline"],
      [{ color: [] }, { background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["clean"],
    ];

    if (editorRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(editorRef.current, {
        theme: "snow",
        modules: { toolbar: toolbarOptions },
        placeholder: "Enter event description here...",
      });

      quillInstance.current.on("text-change", () => {
        const quill = quillInstance.current!;
        const plainText = quill.getText();
        setCharCount(plainText.length);
        
        if (plainText.trim().length <= MAX_LENGTH) {
          const html = quill.root.innerHTML;
          onChange(html);
          setError?.('');
        } else {
          quill.deleteText(MAX_LENGTH, quill.getLength());
          setError?.('Description must not exceed 5000 characters');
        }
      });
    }
  }, [onChange]);

  useEffect(() => {
    if (quillInstance.current && typeof value === 'string') {
      const currentContent = quillInstance.current.root.innerHTML;
      if (currentContent !== value) {
        quillInstance.current.root.innerHTML = value;
      }
    }
  }, [value]);

  return (
    <div>
      <div ref={editorRef} />
      <div style={{position:'absolute',marginLeft:'33%', fontSize: "12px", color: charCount > MAX_LENGTH ? "red" : "#666" }}>
        {charCount} / {MAX_LENGTH}
      </div>
    </div>
  );
};

export default RichTextEditor;



